
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="结合 element-ui" fileName="combine-element-ui.md" />
        <demo-block>
        <div><p>1、你也可以结合 element-ui 组件做日期、数字、下拉等编辑功能<br/>2、注意：组件本身可能会和第三方库组件的快捷键冲突，此时你可以通过 <code>cellSelectionOption</code>去禁用单元格选择功能</p>
</div>
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;button class=&quot;button-demo&quot; @click=&quot;submit()&quot;&gt;提交&lt;/button&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table
            rowKeyFieldName=&quot;rowKey&quot;
            :fixed-header=&quot;true&quot;
            :columns=&quot;columns&quot;
            :table-data=&quot;tableData&quot;
            :cell-selection-option=&quot;cellSelectionOption&quot;
            :row-style-option=&quot;rowStyleOption&quot;
        /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // submit data
                submitData: [
                    // {
                    //     rowKey: 0,
                    //     field: &quot;&quot;,
                    //     value: &quot;&quot;,
                    // },
                ],
                cellSelectionOption: {
                    // default true
                    enable: false,
                },
                columns: [
                    {
                        field: &quot;&quot;,
                        key: &quot;a&quot;,
                        title: &quot;&quot;,
                        width: 50,
                        align: &quot;center&quot;,
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: &quot;name&quot;,
                        key: &quot;name&quot;,
                        title: &quot;Name&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                    },
                    {
                        field: &quot;date&quot;,
                        key: &quot;date&quot;,
                        title: &quot;Date&quot;,
                        align: &quot;left&quot;,
                        width: &quot;15%&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (
                                &lt;el-date-picker
                                    size=&quot;small&quot;
                                    value={row[&quot;date&quot;]}
                                    on-input={(val) =&gt; {
                                        row[&quot;date&quot;] = val;
                                        this.cellDataChange(row, column, val);
                                    }}
                                    type=&quot;date&quot;
                                    value-format=&quot;yyyy-MM-dd&quot;
                                    placeholder=&quot;选择日期&quot;
                                &gt;&lt;/el-date-picker&gt;
                            );
                        },
                    },
                    {
                        field: &quot;age&quot;,
                        key: &quot;age&quot;,
                        title: &quot;Age&quot;,
                        align: &quot;center&quot;,
                        width: &quot;30%&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (
                                &lt;el-input-number
                                    size=&quot;small&quot;
                                    min={1}
                                    value={row[&quot;age&quot;]}
                                    on-input={(val) =&gt; {
                                        row[&quot;age&quot;] = val;
                                    }}
                                    on-change={(val) =&gt; {
                                        this.cellDataChange(row, column, val);
                                    }}
                                &gt;&lt;/el-input-number&gt;
                            );
                        },
                    },
                    {
                        field: &quot;gender&quot;,
                        key: &quot;gender&quot;,
                        title: &quot;Gender&quot;,
                        align: &quot;left&quot;,
                        width: &quot;40%&quot;,
                        renderBodyCell: ({ row, column, rowIndex }, h) =&gt; {
                            return (
                                &lt;el-select
                                    size=&quot;small&quot;
                                    value={row[&quot;gender&quot;]}
                                    on-input={(val) =&gt; {
                                        row[&quot;gender&quot;] = val;
                                        this.cellDataChange(row, column, val);
                                    }}
                                    placeholder=&quot;请选择&quot;
                                &gt;
                                    &lt;el-option label=&quot;female&quot; value=&quot;female&quot;&gt;&lt;/el-option&gt;
                                    &lt;el-option label=&quot;male&quot; value=&quot;male&quot;&gt;&lt;/el-option&gt;
                                &lt;/el-select&gt;
                            );
                        },
                    },
                ],
                // table data
                tableData: [
                    {
                        name: &quot;John&quot;,
                        date: &quot;1900-05-20&quot;,
                        age: 17,
                        gender: &quot;female&quot;,
                        rowKey: 0,
                    },
                    {
                        name: &quot;Dickerson&quot;,
                        date: &quot;1910-06-20&quot;,
                        age: 20,
                        gender: &quot;male&quot;,
                        rowKey: 1,
                    },
                    {
                        name: &quot;Larsen&quot;,
                        date: &quot;2000-07-20&quot;,
                        age: 22,
                        gender: &quot;female&quot;,
                        rowKey: 2,
                    },
                    {
                        name: &quot;Geneva&quot;,
                        date: &quot;2010-08-20&quot;,
                        age: 18,
                        gender: &quot;male&quot;,
                        rowKey: 3,
                    },
                    {
                        name: &quot;Jami&quot;,
                        date: &quot;2020-09-20&quot;,
                        age: 29,
                        gender: &quot;female&quot;,
                        rowKey: 4,
                    },
                ],
            };
        },
        methods: {
            // submit
            submit() {
                alert(JSON.stringify(this.submitData));
            },

            // cell data change
            cellDataChange(row, column, cellValue) {
                const { submitData } = this;

                let currentCell = submitData.find(
                    (x) =&gt; x.rowKey === row[&quot;rowKey&quot;] &amp;&amp; x.field === column.field,
                );

                if (currentCell) {
                    currentCell.value = cellValue;
                } else {
                    let newCell = {
                        rowKey: row[&quot;rowKey&quot;],
                        field: column.field,
                        value: cellValue,
                    };
                    this.submitData.push(newCell);
                }
            },
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('button',{staticClass:"button-demo",on:{"click":function($event){return _vm.submit()}}},[_vm._v("提交")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{attrs:{"rowKeyFieldName":"rowKey","fixed-header":true,"columns":_vm.columns,"table-data":_vm.tableData,"cell-selection-option":_vm.cellSelectionOption,"row-style-option":_vm.rowStyleOption}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                rowStyleOption: {
                    clickHighlight: false,
                    hoverHighlight: false,
                },
                // submit data
                submitData: [
                    // {
                    //     rowKey: 0,
                    //     field: "",
                    //     value: "",
                    // },
                ],
                cellSelectionOption: {
                    // default true
                    enable: false,
                },
                columns: [
                    {
                        field: "",
                        key: "a",
                        title: "",
                        width: 50,
                        align: "center",
                        operationColumn: true,
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return ++rowIndex;
                        },
                    },
                    {
                        field: "name",
                        key: "name",
                        title: "Name",
                        align: "left",
                        width: "15%",
                    },
                    {
                        field: "date",
                        key: "date",
                        title: "Date",
                        align: "left",
                        width: "15%",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return (
                                <el-date-picker
                                    size="small"
                                    value={row["date"]}
                                    on-input={(val) => {
                                        row["date"] = val;
                                        this.cellDataChange(row, column, val);
                                    }}
                                    type="date"
                                    value-format="yyyy-MM-dd"
                                    placeholder="选择日期"
                                ></el-date-picker>
                            );
                        },
                    },
                    {
                        field: "age",
                        key: "age",
                        title: "Age",
                        align: "center",
                        width: "30%",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return (
                                <el-input-number
                                    size="small"
                                    min={1}
                                    value={row["age"]}
                                    on-input={(val) => {
                                        row["age"] = val;
                                    }}
                                    on-change={(val) => {
                                        this.cellDataChange(row, column, val);
                                    }}
                                ></el-input-number>
                            );
                        },
                    },
                    {
                        field: "gender",
                        key: "gender",
                        title: "Gender",
                        align: "left",
                        width: "40%",
                        renderBodyCell: ({ row, column, rowIndex }, h) => {
                            return (
                                <el-select
                                    size="small"
                                    value={row["gender"]}
                                    on-input={(val) => {
                                        row["gender"] = val;
                                        this.cellDataChange(row, column, val);
                                    }}
                                    placeholder="请选择"
                                >
                                    <el-option label="female" value="female"></el-option>
                                    <el-option label="male" value="male"></el-option>
                                </el-select>
                            );
                        },
                    },
                ],
                // table data
                tableData: [
                    {
                        name: "John",
                        date: "1900-05-20",
                        age: 17,
                        gender: "female",
                        rowKey: 0,
                    },
                    {
                        name: "Dickerson",
                        date: "1910-06-20",
                        age: 20,
                        gender: "male",
                        rowKey: 1,
                    },
                    {
                        name: "Larsen",
                        date: "2000-07-20",
                        age: 22,
                        gender: "female",
                        rowKey: 2,
                    },
                    {
                        name: "Geneva",
                        date: "2010-08-20",
                        age: 18,
                        gender: "male",
                        rowKey: 3,
                    },
                    {
                        name: "Jami",
                        date: "2020-09-20",
                        age: 29,
                        gender: "female",
                        rowKey: 4,
                    },
                ],
            };
        },
        methods: {
            // submit
            submit() {
                alert(JSON.stringify(this.submitData));
            },

            // cell data change
            cellDataChange(row, column, cellValue) {
                const { submitData } = this;

                let currentCell = submitData.find(
                    (x) => x.rowKey === row["rowKey"] && x.field === column.field,
                );

                if (currentCell) {
                    currentCell.value = cellValue;
                } else {
                    let newCell = {
                        rowKey: row["rowKey"],
                        field: column.field,
                        value: cellValue,
                    };
                    this.submitData.push(newCell);
                }
            },
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  